import { CodeVerificationControl } from './CodeVerificationControl';

export default CodeVerificationControl;
